module.exports = "<app-splash-card [enableActions]=\"enableActions\" [header]=\"header\" [title]=\"title\"></app-splash-card>\n"